import { memo, useCallback, useEffect, useState } from "react";

import { Card, CardContent, Grid, InputAdornment, TextField, Typography } from "@material-ui/core";

import AddCircleOutline from '@material-ui/icons/AddCircleOutline'
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import AssignmentReturnOutlinedIcon from '@material-ui/icons/AssignmentReturnOutlined';

import { useDrop } from "react-dnd";
import update from "immutability-helper";
import { useSnackbar } from "notistack";

import { ItemTypes } from "../ItemTypes";
import { CardCampo } from "../cardCampo";

import {
  atualizar,
  cadastrar,
} from "../../../../services/formulario/FormularioService";

import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";

const useStyles = makeStyles({
  botaoSalvarEFechar: {
    borderRadius: 6,
    fontFamily: "IBM Plex Sans",
    fontSize: 14,
    fontWeight: 500,
    boxShadow: "none",
    textTransform: "none",
    padding: "0.5rem",
  },
});

  const ContainerDragAndDrop = memo(function ContainerDragAndDrop({
  formularioEditar,
  formularioDuplicar,
  history,
}) {
  const [cards, setCards] = useState([]);
  const [idFormulario, setIdFormulario] = useState(0);
  const [nomeFormulario, setNomeFormulario] = useState('');
  const { enqueueSnackbar } = useSnackbar();

  const classes = useStyles();

  const encontrarCard = useCallback(
    (id) => {
      const card = cards.filter((c) => `${c.id}` === id)[0];

      return {
        card,
        index: cards.indexOf(card),
      };
    },
    [cards]
  );

  const moverCard = useCallback(
    (id, atIndex) => {
      const { card, index } = encontrarCard(id);
      setCards(
        update(cards, {
          $splice: [
            [index, 1],
            [atIndex, 0, card],
          ],
        })
      );
    },
    [encontrarCard, cards, setCards]
  );

  const gerarIdLocal = () => {
    const ids = cards.map((card) => card.id);

    let novoId;

    do {
      // números improváveis de já existirem no banco de dados
      novoId = Math.floor(Math.random() * (10000 - 9950) + 9950);
    } while (ids.includes(novoId));

    return novoId;
  };

  const handleAdicionarCardNovo = () => {
    const novoCard = {
      id: gerarIdLocal(),
      obrigatorio: true,
      nomeCampo: "",
      ordemCampo: cards.length,
      origemBD: false,
    };
    setCards([...cards, novoCard]);
  };

  const organizarCardsBD = () => {
    return cards.map((card, index) => {
      const cardId = card.origemBD == false ? 0 : card.id;
      return {
        id: cardId,
        obrigatorio: card.obrigatorio,
        nomeCampo: card.nomeCampo,
        ordemCampo: index,
      };
    });
  };

  const validarPreenchimento = () => {
    if (nomeFormulario == "") {
      enqueueSnackbar("O Formulário precisa ter um título", {
        variant: "warning",
      });
      return false;
    }

    if (cards.length == 0) {
      enqueueSnackbar("O Formulário precisa de pelo menos 1 campo cadastrado", {
        variant: "warning",
      });
      return false;
    }

    if (cards.some((card) => card.nomeCampo == "")) {
      enqueueSnackbar("Todos os campos precisam ter um título", {
        variant: "warning",
      });
      return false;
    }

    return true
  }

  const handleSalvar = async (redirecionarFormularios) => {
    if(!validarPreenchimento)
      return

    const cardsOrganizados = organizarCardsBD();

    const dataCadastrar = {
      nomeFormulario: nomeFormulario,
      ativo: true,
      campos: cardsOrganizados,
    };

    if (idFormulario != 0) {
      try {
        await atualizar(idFormulario, dataCadastrar)
          .then((response) => {
            if (response && response.status === 200) {
              atualizarDadosLocalmente(response.data);
              enqueueSnackbar("Formulário atualizado com sucesso", {
                variant: "success",
              });

              if (redirecionarFormularios === true) {
                setTimeout(() => history.push("/formularios"), 500);
              }
            } else {
              enqueueSnackbar("Erro ao atualizar o Formulário", {
                variant: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error.response.status); //401
            console.log(error.response.data.error); // Please Authenticate
          });
      } catch (e) {
        console.log("---- error");
        console.log(e);
        enqueueSnackbar("Erro ao atualizar o Formulário", { variant: "error" });
      }
    } else {
      try {
        await cadastrar(dataCadastrar)
          .then((response) => {
            if (response && response.status === 201) {
              console.log(response);
              atualizarDadosLocalmente(response.data);
              enqueueSnackbar("Formulário salvo com sucesso", {
                variant: "success",
              });

              if (redirecionarFormularios === true) {
                setTimeout(() => history.push("/formularios"), 500);
              }
            }
          })
          .catch(function (error) {
            console.log(error.response.status); //401
            console.log(error.response.data.error); // Please Authenticate
          });
      } catch (e) {
        console.log("---- error");
        console.log(e);
        enqueueSnackbar("Erro ao salvar o Formulário", { variant: "error" });
      }
    }
  };

  const handleSalvarFechar = async () => {
    handleSalvar(true);
  };

  const atualizarDadosLocalmente = (data) => {
    let cardsAtualizados = [];
    data.campos.map((card) => {
      cardsAtualizados = [
        ...cardsAtualizados,
        {
          id: card.id,
          obrigatorio: card.obrigatorio,
          nomeCampo: card.nomeCampo,
          ordemCampo: card.ordemCampo,
          origemBD: true,
        },
      ];
    });
    setCards(cardsAtualizados);
    setIdFormulario(data.id);
    setNomeFormulario(data.nomeFormulario);
  };

  const salvarCheckboxObrigatorio = (idCard, checked) => {
    const item = cards.find((obj) => {
      if (obj.id == idCard) return obj;
    });
    if (item != -1) item.obrigatorio = checked;
  };

  const salvarInputNomeCampo = (idCard, value) => {
    const item = cards.find((obj) => {
      if (obj.id == idCard) return obj;
    });
    item.nomeCampo = value;
  };

  const handleInputFormularioTitulo = (event) => {
      setNomeFormulario(event.target.value );
  };

  const duplicarCard = (idCard) => {
    let resultCards = [];
    let encontrado = false;

    cards.forEach((element) => {
      if (element.id == idCard) {
        encontrado = true;

        let novoElement = { ...element };
        novoElement.id = gerarIdLocal();
        novoElement.nomeCampo = "Duplicado " + element.nomeCampo;
        resultCards.push(novoElement);
      }

      if (encontrado == true) {
        element.ordemCampo += 1;
        resultCards.push(element);
      } else {
        resultCards.push(element);
      }
    });

    setCards(resultCards);
  };

  const excluirCard = (idCard) => {
    const result = cards.filter((card) => idCard != card.id);
    setCards(result);
  };

  useEffect(() => {
    if (formularioEditar != null) {
      setIdFormulario(formularioEditar.id);
      setNomeFormulario(formularioEditar.nomeFormulario);

      setCards(
        formularioEditar.campos.map((campo) => {
          return {
            id: campo.id,
            obrigatorio: campo.obrigatorio,
            nomeCampo: campo.nomeCampo,
            ordemCampo: campo.ordemCampo,
          };
        })
      );
    } else if (formularioDuplicar != null) {
      setIdFormulario(0);
      setNomeFormulario(formularioDuplicar.nomeFormulario);

      setCards(
        formularioDuplicar.campos.map((campo) => {
          return {
            id: gerarIdLocal(),
            obrigatorio: campo.obrigatorio,
            nomeCampo: campo.nomeCampo,
            ordemCampo: campo.ordemCampo,
          };
        })
      );
      enqueueSnackbar("Formulário Duplicado com sucesso", {
        variant: "success",
      });
    } else {
      setCards(cards);
    }
  }, []);

  const [, drop] = useDrop(() => ({ 
    accept: ItemTypes.CARD 
  }));

  return (
    <>
      <Grid
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Card>
          <CardContent>
            <TextField
              label="Nome do Formulário"
              onChange={handleInputFormularioTitulo}
              placeholder="Nome do Formulário"
              value={nomeFormulario}
              fullWidth
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}

              style={{margin: "20px 0"}}
              />
            <Typography style={{marginTop: "20px"}}  variant="caption">
              O Conselho Deliberativo Nacional (CDN) é o órgão colegiado de
              direção superior do Sebrae
            </Typography>
          </CardContent>
          
        </Card>
      </Grid>
      <Grid >
        <Grid ref={drop} style={{ margin: "20px 0" }}>
          {cards.map((card, index) => (
            <CardCampo
              key={card.id}
              id={`${card.id}`}
              obrigatorio={card.obrigatorio}
              nomeCampo={card.nomeCampo}
              ordemCampo={index}
              salvarCheckboxObrigatorio={salvarCheckboxObrigatorio}
              salvarInputNomeCampo={salvarInputNomeCampo}
              moverCard={moverCard}
              encontrarCard={encontrarCard}
              duplicarCard={duplicarCard}
              excluirCard={excluirCard}
            />
          ))}
        </Grid>

          <Card style={{border: "2px dashed #8FB8EF", marginBottom: "30px"}}>
            <CardContent style={{paddingBottom:"16px"}}>
              <Button
                variant="contained"
                className={classes.botaoSalvarEFechar}
                onClick={handleAdicionarCardNovo}
                style={{marginRight: "20px"}}
              >
                <InputAdornment position="start">
                  <AddCircleOutline style={{ cursor: "pointer" }} />
                </InputAdornment>
                Adicionar campo
              </Button>
              <Typography style={{ fontStyle: 'italic'}} variant="caption" >
                Adicionar uma nova sessão para o formulário
              </Typography>
            </CardContent>
          </Card>
      </Grid>
      <Grid style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
        <Button
          variant="contained"
          className={classes.botaoSalvarEFechar}
          onClick={handleSalvar}
          style={{backgroundColor:"#35B068"}}
        >
          <InputAdornment position="start">
            <AssignmentTurnedInOutlinedIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          Salvar
        </Button>
        <Button
          variant="outlined"
          className={classes.botaoSalvarEFechar}
          onClick={handleSalvarFechar}
          style={{color:"#35B068"}}
        >
          <InputAdornment position="start">
            <AssignmentReturnOutlinedIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          Salvar e fechar
        </Button>
      </Grid>
    </>
  );
});

export default ContainerDragAndDrop;
